import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import style from './customer-auto-complete.module.css';
import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

/**
 * Prevents the blur event from firing on the input when clicking a dropdown item.
 * This ensures the click event on the dropdown item fires before the input loses focus.
 * @param {object} event triggered by the mouseDown event
 * @returns {void}
 */
const preventMouseDownBlur = (event) => event.preventDefault();

/**
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.city
 * @param {string} props.state
 * @param {(index: number, path: string) => void} props.onRowClick
 * @param {number} props.index
 * @param {string} props.path
 * @returns {JSX.Element}
 */
const CustomerRow = ({ name = '', city = '', state = '', onRowClick, index, path = '' }) => (
  <DropdownMenuItem className={style.row} onClick={() => onRowClick(index, path)}>
    {name}
    <span className={style['row-location']}>
      ({city}, {state})
    </span>
  </DropdownMenuItem>
);

/**
 * @typedef {object} Customer
 * @property {string} name
 * @property {string} city
 * @property {string} state
 */

/**
 * @param {object} props
 * @param {Customer[]} props.customers
 * @param {(index: number, path: string) => void} props.onRowClick
 * @param {string} props.path
 * @returns {JSX.Element}
 */
export const CustomerAutoComplete = ({ customers = emptyArray, onRowClick = noop, path = '' }) => (
  <div className={style.container} onMouseDown={preventMouseDownBlur}>
    {(customers ?? []).map((customer, idx) => (
      <CustomerRow
        key={idx}
        city={customer.city}
        index={idx}
        name={customer.name}
        onRowClick={onRowClick}
        path={path}
        state={customer.state}
      />
    ))}
  </div>
);
